export default __webpack_public_path__ + "static/media/gardening-service.e05cbcf5.jpg";